import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import {
  formatBytes,
  getFileExtension,
  createPDFDocumentUsingImages,
  convertImageToMimeType,
  saveFile,
  desiredDPI,
} from "../Utils";
import ImageViewerView from "../image_viewer/ImageViewerView";

function Image2PdfImagesListScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //fileinfo list
  //store thumbnail, page count etc key is filepath
  const [filesInfo, setFilesInfo] = useState({});
  //is converting
  const [isConverting, setIsConverting] = useState(false);
  //set generated pdf fuilename
  const [generatedPdfFilename, setGeneratedPdfFilename] = useState("converted");
  //export file details
  const [exportFileDetails, setExportFileDetails] = useState({
    password: "",
    width: 8.3 * desiredDPI, //a4 page dimension
    height: 11.7 * desiredDPI, //a4 page dimension
    compress: true,
    pageLayout: "A4",
    exportPageLayoutPopupShowing: false,
  });

  //show image preview
  const [showImagePreview, setShowImagePreview] = useState({
    preview: false,
    file: null,
  });

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //generate thumbnails
      generateThumbnails();

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles]);

  //generate thumbnails
  const generateThumbnails = () => {
    //loop
    //read files
    //get thumbnails
    for (let i = 0; i < selectedFiles.length; i++) {
      //selected file
      const selectedFile = selectedFiles[i];
      //path pdf file
      const key = String(selectedFile.path);
      //set image
      setFilesInfo((prevDictionary) => ({
        ...prevDictionary,
        [key]: {
          ...filesInfo[key],
          state: AppState.LOADED,
          thumbnail: URL.createObjectURL(selectedFile),
          message: "",
          name: selectedFile.name,
          file: selectedFile, //selected file
          size: selectedFile.size, //in bytes
        },
      }));
    }
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setShowEditFileScreen(false);
    setFilesInfo({});
    setStartProcessingFiles(false);
  };

  //on chnage checkbox values
  const onChangeCheckboxValues = (e) => {
    //set
    setExportFileDetails({
      ...exportFileDetails,
      compress: e.target.checked,
    });
  };

  //on  filename value changed
  const onFilenameValueChanged = (e) => {
    //set values
    setGeneratedPdfFilename(e.target.value);
  };

  //on  password value changed
  const onPasswordValueChanged = (e) => {
    //set values
    setExportFileDetails({ ...exportFileDetails, password: e.target.value });
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    selectedFiles.map((item, index) => (
      <div
        className="mt-3"
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //show preview
          setShowImagePreview({
            ...showImagePreview,
            preview: true,
            file: item,
          });
        }}
      >
        {/* Flex container left image pdf right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* Arrow */}
          <div
            className="justify-content-center align-items-center text-center btn-group-vertical"
            data-toggle="buttons"
          >
            {/* Up Arrow */}
            <button
              className="btn btn-outline-secondary btn-sm border-0"
              type="button"
              onClick={(e) => {
                // Stops the click from bubbling up to the 'div' above
                e.stopPropagation(); // W3C standard
                //blur
                e.currentTarget.blur();
                //destination index
                let targetIndex = Math.max(0, index - 1);
                //filter array
                //remove element from array
                let filteredArray = selectedFiles.filter((a) => a !== item);
                //Create the first part of the array (before the index)
                const firstPart = filteredArray.slice(0, targetIndex);
                //Create the second part of the array (from the index onwards)
                const secondPart = filteredArray.slice(targetIndex);
                //Combine them into a new array with the new item inserted
                const updatedItems = [...firstPart, item, ...secondPart];
                //set
                setSelectedFiles(updatedItems);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-caret-up-fill"
                viewBox="0 0 16 16"
              >
                <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
              </svg>
            </button>
            {/* Down Arrow */}
            <button
              className="btn btn-outline-secondary btn-sm border-0"
              type="button"
              onClick={(e) => {
                // Stops the click from bubbling up to the 'div' above
                e.stopPropagation(); // W3C standard
                //blur
                e.currentTarget.blur();
                //destination index
                let targetIndex = Math.min(selectedFiles.length - 1, index + 1);
                //filter array
                //remove element from array
                let filteredArray = selectedFiles.filter((a) => a !== item);
                //Create the first part of the array (before the index)
                const firstPart = filteredArray.slice(0, targetIndex);
                //Create the second part of the array (from the index onwards)
                const secondPart = filteredArray.slice(targetIndex);
                //Combine them into a new array with the new item inserted
                const updatedItems = [...firstPart, item, ...secondPart];
                //set
                setSelectedFiles(updatedItems);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
              >
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
              </svg>
            </button>
          </div>
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].thumbnail != null
                      ? filesInfo[String(item.path)].thumbnail
                      : "./images/file_icon.png"
                    : "./images/file_icon.png"
                }
                alt="pdf_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">{item.name}</div>
            <div className="d-flex">
              {/* File size */}
              <div className="px-2 fs-6 text-body-secondary">
                Size: {formatBytes(item.size)}
              </div>
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].state === AppState.PROCESSED
                      ? "text-success"
                      : "bg-danger text-white"
                    : "bg-danger text-white"
                }`}
              >
                {String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? "PROCESSED"
                    : getFileExtension(item.name.toUpperCase())
                  : getFileExtension(item.name.toUpperCase())}
              </div>
            </div>
            {/* Page Count */}
            <div className="px-2 fs-6 text-body-secondary">
              {`Page: ${index + 1}`}
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].message !== ""
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {String(item.path) in filesInfo
                ? filesInfo[String(item.path)].message
                : ""}
            </div>
          </div>

          {/* Right side views spinner, download and delete buttons */}
          {/* Show spinner while processing */}
          {/* Spinner */}
          <div
            className="position-absolute justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            <div
              className={`spinner-border my-auto me-2 ms-sm-3 ms-2 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSING
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.LOADED ||
                    filesInfo[String(item.path)].state === AppState.NONE
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //remove file from selectedfiles list
                  setSelectedFiles(selectedFiles.filter((a) => a !== item));
                  //remove thumbnails
                  setFilesInfo((currentData) => {
                    // Destructure the key to remove into a throwaway variable (e.g., '_')
                    // and collect the rest of the properties into a new object 'rest'
                    const { [String(item.path)]: _, ...rest } = currentData;
                    //return
                    return rest;
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    //show hide loading view
    <div className="position-relative">
      {/* show pdf preview */}
      {/* page main content */}
      {showImagePreview.preview ? (
        <ImageViewerView
          title={
            showImagePreview.file === null ? "" : showImagePreview.file.name
          }
          onClose={() => {
            //set preview
            setShowImagePreview({
              ...showImagePreview,
              preview: false,
              file: null,
            });
          }}
          file={showImagePreview.file}
        ></ImageViewerView>
      ) : (
        <div>
          {/* Top bar */}
          <div className="bg-light border-bottom my-auto sticky-top">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={resetScreen}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#000000"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
              {/* Title */}
              <label className="fs-3 ms-2 py-2 text-secondary fs-4">
                {props.title ?? "Image To PDF Converter"}
              </label>
            </div>
          </div>

          {/*Container left list & right controls */}
          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 52px)",
              maxHeight: "calc(100vh - 52px)",
            }}
          >
            {/* Left List */}
            <div
              className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
              style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
            >
              {renderFilesListView()}
            </div>

            {/* Right controls */}
            <div
              className="ms-sm-5 ms-1  border-start position-relative"
              style={{
                marginBottom: "100px", //add space to bottom for button, else overlap
                width: "25%",
                maxWidth: "25%",
                overflowY: "auto",
                minWidth: "200px",
              }}
            >
              {" "}
              {/* Label filename input */}
              <div>
                <label
                  htmlFor="outputFilename"
                  className="form-label mt-5 ms-4 fs-4 text-dark"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Output filename"
                >
                  Output filename:
                </label>
                <input
                  type="email"
                  className="form-control ms-4 mt-3 me-4"
                  id="filenameInput"
                  aria-describedby="filename"
                  placeholder="Output filename (xyz)"
                  onChange={onFilenameValueChanged}
                  style={{ width: "calc(100% - 48px)" }}
                />
              </div>
              {/* Label Password input */}
              <div>
                <label
                  htmlFor="password"
                  className="form-label mt-4 ms-4 fs-4 text-dark"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Encryption details"
                >
                  Encrypt PDF:
                </label>
                <input
                  type="password"
                  className="form-control ms-4 mt-3 me-4"
                  id="passwordInput"
                  aria-describedby="password"
                  placeholder="Enter password"
                  onChange={onPasswordValueChanged}
                  style={{ width: "calc(100% - 48px)" }}
                />
              </div>
              {/* Page size */}
              <div>
                <label
                  className="mt-5 ms-4 fs-4 text-dark border-top py-2"
                  title="Settings"
                  style={{ width: "calc(100% - 48px)" }}
                >
                  Settings:
                </label>

                {/* Page size */}
                <div className="d-flex ms-4 mt-2 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">
                    Page Layout:
                  </label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenu"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //toggle
                        setExportFileDetails({
                          ...exportFileDetails,
                          exportPageLayoutPopupShowing:
                            exportFileDetails.exportPageLayoutPopupShowing ===
                            true
                              ? false
                              : true,
                        });
                      }}
                    >
                      {exportFileDetails.pageLayout}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        exportFileDetails.exportPageLayoutPopupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenu"
                    >
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 8.3 * desiredDPI,
                            height: 11.7 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: "A4",
                          });
                        }}
                      >
                        A4
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 11.7 * desiredDPI,
                            height: 16.5 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: "A3",
                          });
                        }}
                      >
                        A3
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 5.8 * desiredDPI,
                            height: 8.3 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: "A5",
                          });
                        }}
                      >
                        A5
                      </button>{" "}
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 4.1 * desiredDPI,
                            height: 5.8 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: "A6",
                          });
                        }}
                      >
                        A6
                      </button>{" "}
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 6.9 * desiredDPI,
                            height: 9.8 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: "B5",
                          });
                        }}
                      >
                        B5
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 7.25 * desiredDPI,
                            height: 10.5 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: "Executive",
                          });
                        }}
                      >
                        Executive
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 8.5 * desiredDPI,
                            height: 11 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: "US Letter",
                          });
                        }}
                      >
                        US Letter
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 8.5 * desiredDPI,
                            height: 14 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: "Legal",
                          });
                        }}
                      >
                        Legal
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 11 * desiredDPI,
                            height: 17 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: "Tabloid/Ledger",
                          });
                        }}
                      >
                        Tabloid/Ledger
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 12 * desiredDPI,
                            height: 18 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: 'ARCH B (12" x 18")',
                          });
                        }}
                      >
                        ARCH B (12" x 18")
                      </button>{" "}
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 18 * desiredDPI,
                            height: 24 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: 'ARCH C (18" x 24")',
                          });
                        }}
                      >
                        ARCH C (18" x 24")
                      </button>{" "}
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 24 * desiredDPI,
                            height: 36 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: 'ARCH D (24" x 36")',
                          });
                        }}
                      >
                        ARCH D (24" x 36")
                      </button>{" "}
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 6 * desiredDPI,
                            height: 9 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: '6" x 9"',
                          });
                        }}
                      >
                        6" x 9"
                      </button>{" "}
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 5.5 * desiredDPI,
                            height: 8.5 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: '5.5" x 8.5"',
                          });
                        }}
                      >
                        5.5" x 8.5"
                      </button>{" "}
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set page size
                          setExportFileDetails({
                            ...exportFileDetails,
                            width: 12 * desiredDPI,
                            height: 12 * desiredDPI,
                            exportPageLayoutPopupShowing: false,
                            pageLayout: '12" x 12"',
                          });
                        }}
                      >
                        12" x 12"
                      </button>
                    </div>
                  </div>
                </div>
                {/* Checkbox Grayscale */}
                <div className="form-check mt-2 ms-4">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    checked={exportFileDetails.compress}
                    id="compressimage"
                    onChange={onChangeCheckboxValues}
                  />
                  <label
                    className="form-check-label text-secondary"
                    htmlFor="compressimage"
                  >
                    Compress
                  </label>
                </div>
              </div>
              {/* Convert Button */}
              <button
                className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                  isConverting ? "disabled" : ""
                }`}
                style={{
                  marginLeft: "10px",
                  width:
                    window !== undefined
                      ? window.innerWidth * 0.25 < 200
                        ? "180px"
                        : window.innerWidth * 0.25 - 40
                      : "180px",
                  bottom: "10px",
                }}
                type="button"
                onClick={async (e) => {
                  //set
                  setIsConverting(true);
                  //images
                  try {
                    //images
                    var images = [];
                    //loop
                    for (var i = 0; i < selectedFiles.length; i++) {
                      //selected file
                      const selectedFile = selectedFiles[i];
                      //key
                      const key = String(selectedFile.path);
                      //check
                      if (key in filesInfo) {
                        //set image
                        setFilesInfo((prevDictionary) => ({
                          ...prevDictionary,
                          [key]: {
                            ...filesInfo[key],
                            state: AppState.PROCESSED,
                            message: "Reading file...",
                          },
                        }));
                      }
                      //data as blob
                      //covert to jpeg
                      //as pdfs are generated from jpeg
                      const data = await convertImageToMimeType(
                        selectedFile,
                        "image/jpeg",
                        exportFileDetails.compress === true ? 0.5 : 1.0,
                      );
                      //append
                      images.push(data);

                      //check
                      if (key in filesInfo) {
                        //set image
                        setFilesInfo((prevDictionary) => ({
                          ...prevDictionary,
                          [key]: {
                            ...filesInfo[key],
                            state: AppState.PROCESSED,
                            message:
                              "Successfully processed file. Generated pdf will be downloaded automatically.",
                          },
                        }));
                      }
                    }

                    // generate new pdf
                    // with images
                    await createPDFDocumentUsingImages(
                      "Image to PDF",
                      images,
                      [exportFileDetails.width, exportFileDetails.height],
                      exportFileDetails.password,
                      async (blob) => {
                        //save pdf
                        await saveFile(blob, `${generatedPdfFilename}.pdf`);
                      },
                    );
                  } catch (e) {
                    console.log(e);
                  }
                  //reset
                  setIsConverting(false);
                }}
              >
                Generate
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Image2PdfImagesListScreen;
